"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var index_1 = tslib_1.__importDefault(require("../../index"));
var client_1 = require("../../resources/client");
var resources = tslib_1.__importStar(require("../../resources"));
var instanceUtils = tslib_1.__importStar(require("../../util/instances"));
var resolve_1 = require("../../util/resources/resolve");
// Components
var ResourceList_1 = tslib_1.__importDefault(require("../../components/ResourceList"));
var ResourceAttribute_1 = tslib_1.__importDefault(require("../../components/ResourceAttribute"));
var ResourceEditForm_1 = tslib_1.__importDefault(require("../../components/ResourceEditForm"));
var ResourceDistLinesSimple_1 = tslib_1.__importDefault(require("../../components/ResourceDistLinesSimple"));
var InputSelectRelatedResource_1 = tslib_1.__importDefault(require("../../components/InputSelectRelatedResource"));
var TrResourceEdit_1 = tslib_1.__importDefault(require("../../components/TrResourceEdit"));
var TrResourceEditThead_1 = tslib_1.__importDefault(require("../../components/TrResourceEditThead"));
function getLocalInstances() {
    return JSON.parse(localStorage.getItem('instances')) || {};
}
exports.getLocalInstances = getLocalInstances;
function setLocalInstance(hostname, token) {
    var instances = getLocalInstances();
    instances[hostname] = { token: token };
    localStorage.setItem('instances', JSON.stringify(instances));
}
exports.setLocalInstance = setLocalInstance;
function getLocalToken(hostname) {
    var local = getLocalInstances()[hostname];
    if (!local) {
        throw new RedirectableError("No local token is defined for " + hostname);
    }
    return local.token;
}
exports.getLocalToken = getLocalToken;
function clearLocalInstance(hostname) {
    var instances = getLocalInstances();
    delete instances[hostname];
    localStorage.setItem('instances', JSON.stringify(instances));
}
exports.clearLocalInstance = clearLocalInstance;
function setInstance(hostname, token) {
    index_1.default.setInstance(hostname, token);
    index_1.default.client.axios.interceptors.request.use(client_1.createTokenPrefetchInterceptor(index_1.default.client));
    index_1.default.client.events.on('token.renews', function (e) {
        setLocalInstance(index_1.default.client.hostname, index_1.default.client.token);
    });
    var currentLocal = getLocalInstances()[hostname];
    if (token && (!currentLocal || (currentLocal && currentLocal.token !== token))) {
        setLocalInstance(hostname, token);
    }
}
exports.setInstance = setInstance;
function login(hostname, username, password) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var user;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setInstance(hostname);
                    return [4 /*yield*/, index_1.default.login(username, password)];
                case 1:
                    user = _a.sent();
                    setLocalInstance(hostname, index_1.default.client.token);
                    return [2 /*return*/, user];
            }
        });
    });
}
exports.login = login;
function getTokenPayload(token) {
    try {
        var jwtPieces = token.split('.');
        var payloadBase64 = jwtPieces[1];
        var payloadBuffer = Buffer.from(payloadBase64, 'base64').toString();
        return JSON.parse(payloadBuffer.toString());
    }
    catch (e) {
        return undefined;
    }
}
exports.getTokenPayload = getTokenPayload;
var RedirectableError = /** @class */ (function (_super) {
    tslib_1.__extends(RedirectableError, _super);
    function RedirectableError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.redirectable = true;
        return _this;
    }
    return RedirectableError;
}(Error));
exports.RedirectableError = RedirectableError;
exports.sigmaPlugins = tslib_1.__assign({}, instanceUtils, { Sigma: index_1.default,
    resources: resources,
    login: login,
    setInstance: setInstance,
    getLocalToken: getLocalToken,
    getLocalInstances: getLocalInstances,
    getTokenPayload: getTokenPayload, requireResource: resolve_1.requireResourceByModelName, clearAllCache: index_1.default.clearAllCache.bind(index_1.default) });
exports.default = {
    install: function (Vue, options) {
        Vue.prototype.$sigma = exports.sigmaPlugins;
        Vue.prototype.$resources = exports.sigmaPlugins.resources;
        //Vue.mixin(messages)
        Vue.mixin({
            components: {
                ResourceList: ResourceList_1.default,
                ResourceAttribute: ResourceAttribute_1.default,
                ResourceEditForm: ResourceEditForm_1.default,
                ResourceDistLinesSimple: ResourceDistLinesSimple_1.default,
                InputSelectRelatedResource: InputSelectRelatedResource_1.default,
                TrResourceEdit: TrResourceEdit_1.default,
                TrResourceEditThead: TrResourceEditThead_1.default
            },
        });
    },
};
//# sourceMappingURL=sigma.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/components/plugins/sigma.js
// module id = HCMf
// module chunks = 0